module.exports = __webpack_public_path__ + "img/1.ac3a1591.png";